import type { ReactNode } from "react";
import styles from "./EmptyState.module.css";

interface EmptyStateProps {
	/** Emoji or icon to display */
	icon?: string;
	/** Primary title */
	title: string;
	/** Secondary hint/description — supports \n for line breaks */
	hint?: string;
	/** Call-to-action button label */
	ctaLabel?: string;
	/** Call-to-action click handler */
	onCta?: () => void;
	/** Replace default content entirely */
	children?: ReactNode;
}

/**
 * Rich empty-state panel — icon, title, hint, optional CTA.
 * Use whenever a list/page has no data to display.
 * Shared across all pages to guarantee consistent "empty states that teach."
 */
export function EmptyState({ icon, title, hint, ctaLabel, onCta, children }: EmptyStateProps) {
	return (
		<div className={styles.root}>
			{icon && <div className={styles.icon}>{icon}</div>}
			<div className={styles.title}>{title}</div>
			{hint && <div className={styles.hint}>{hint}</div>}
			{children}
			{ctaLabel && onCta && (
				<button type="button" className={styles.cta} onClick={onCta}>
					{ctaLabel}
				</button>
			)}
		</div>
	);
}
